var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "footer-wrap" }, [
        _c("div", { staticClass: "footer-logo" }),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _vm._v("\n      본사 : 인천광역시 연수구 송도미래로 30, 디동 1007호"),
          _c("br"),
          _vm._v(
            "\n      오피스 : 서울특별시 금천구 디지털로9길 68, 1106호 (가산동, 대륭포스트타워 5차)"
          ),
          _c("br")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "spacer" }),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _vm._v("\n      대표이사 : 박종관, 하상욱"),
          _c("br"),
          _vm._v(
            "\n      사업자번호 : 242-86-00160 │ 통신판매업신고번호 제2021-인천연수구-2269호"
          ),
          _c("br"),
          _vm._v("\n      Copyright ⓒ 2020 carang. All rights reserved."),
          _c("br")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c56dd1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c56dd1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inc/Footer.vue
// module id = null
// module chunks = 